import { useStore } from "./store";

export const FULLSCREEN_MODAL_PORTAL_ID = "fullscreen-modal-portal";

/**
 * Returns the portal container element when in fullscreen, so modals can render inside
 * the fullscreen layer instead of behind it. Pass to UNSTABLE_portalContainer on Modal/ModalOverlay.
 */
export function useFullscreenModalContainer(): Element | undefined {
	const isFullscreen = useStore((s) => s.isFullscreen);

	if (!isFullscreen) return undefined;
	return document.getElementById(FULLSCREEN_MODAL_PORTAL_ID) ?? undefined;
}
